import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Form, Row, Col, Alert } from 'react-bootstrap';
import axios from '../../axios/axiosconf';
import DienteSVG from './DienteSVG';
import html2pdf from "html2pdf-fix-jspdf"; // Import para PDF

const ModalOdontograma = ({ show, onHide, pacienteId, paciente }) => {
    // Estados principales
    const [view, setView] = useState('list'); // 'list', 'create', 'show'
    const [loading, setLoading] = useState(false);
    const [odontogramas, setOdontogramas] = useState([]);

    // Estado del Odontograma actual (Edición o Visualización)
    const [dientesState, setDientesState] = useState({});
    const [fechaHora, setFechaHora] = useState('');
    const [profesionalName, setProfesionalName] = useState('');
    const [herramienta, setHerramienta] = useState({ id: 'seleccion', label: 'Seleccionar (Ver)', tipo: 'none' });
    const [observaciones, setObservaciones] = useState('');

    // Datos del usuario logueado
    const [userData, setUserData] = useState(null);
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // Herramientas / Convenciones
    const herramientas = [
        // Fila 1
        { id: 'endodoncia_realizada', label: 'Endodoncia Realizada', color: 'blue', tipo: 'atributo', key: 'endodoncia', value: 'realizada', symbol: '△' },
        { id: 'provisional_presente', label: 'Provisional Presente', color: 'blue', tipo: 'atributo', key: 'provisional', value: 'presente', symbol: 'P' },
        { id: 'corona_desadaptada', label: 'Corona Desadaptada', color: 'red', tipo: 'atributo', key: 'corona', value: 'desadaptada', symbol: '○' },
        { id: 'caries', label: 'Caries', color: '#dc3545', tipo: 'sector' },

        // Fila 2
        { id: 'endodoncia_indicada', label: 'Endodoncia Indicada', color: 'red', tipo: 'atributo', key: 'endodoncia', value: 'indicada', symbol: '△' },
        { id: 'provisional_indicado', label: 'Provisional Indicado', color: 'red', tipo: 'atributo', key: 'provisional', value: 'indicado', symbol: 'P' },
        { id: 'corona_presente', label: 'Corona Presente', color: 'blue', tipo: 'atributo', key: 'corona', value: 'presente', symbol: '○' },
        { id: 'obturacion', label: 'Obturación', color: '#007bff', tipo: 'sector' },

        // Fila 3
        { id: 'sellante_presente', label: 'Sellante Presente', color: 'blue', tipo: 'atributo', key: 'sellante', value: 'presente', symbol: 'S' },
        { id: 'implante_integrado', label: 'Implante Integrado', color: 'blue', tipo: 'atributo', key: 'implante', value: 'integrado', symbol: '¦' },
        { id: 'nucleo_indicado', label: 'Núcleo Indicado', color: 'red', tipo: 'atributo', key: 'nucleo', value: 'indicado', symbol: '▲' },
        { id: 'resina_indicada', label: 'Resina Indicada', color: 'red', tipo: 'sector' },

        // Fila 4
        { id: 'sellante_indicado', label: 'Sellante Indicado', color: 'red', tipo: 'atributo', key: 'sellante', value: 'indicado', symbol: 'S' },
        { id: 'implante_no_integrado', label: 'Implante No Integrado', color: 'red', tipo: 'atributo', key: 'implante', value: 'no_integrado', symbol: '¦' },
        { id: 'nucleo_presente', label: 'Núcleo', color: 'green', tipo: 'atributo', key: 'nucleo', value: 'presente', symbol: '▲' },
        { id: 'resina_presente', label: 'Resina Presente', color: 'blue', tipo: 'sector' },

        // Fila 5
        { id: 'ausente', label: 'Diente Ausente', color: 'black', tipo: 'condicion', value: 'ausente', symbol: '❙' },
        { id: 'pontico', label: 'Póntico', color: 'green', tipo: 'condicion', value: 'pontico', symbol: '⫘' },
        { id: 'exodoncia_indicada', label: 'Exodoncia Indicada', color: 'red', tipo: 'condicion', value: 'exodoncia_indicada', symbol: '❌' },
        { id: 'limpiar_sector', label: 'Borrar Sector', color: '#ffc107', tipo: 'sector' },

        // Fila 6
        { id: 'extraccion', label: 'Diente Extraído', color: 'red', tipo: 'condicion', value: 'extraccion', symbol: '❙' },
        { id: 'pilar_izquierdo', label: 'Pilar Izquierdo', color: 'green', tipo: 'condicion', value: 'pilar_izquierdo', symbol: '⫗' },
        { id: 'brackets', label: 'Brackets', color: 'red', tipo: 'atributo', key: 'brackets', value: 'presente', symbol: '▣' },
        { id: 'limpiar_diente', label: 'Limpiar Diente', color: '#f39c12', tipo: 'accion_diente' },

        // Fila 7
        { id: 'carilla_presente', label: 'Carilla Presente', color: 'blue', tipo: 'sector' },
        { id: 'pilar_derecho', label: 'Pilar Derecho', color: 'green', tipo: 'condicion', value: 'pilar_derecho', symbol: '⫙' },
        { id: 'rotacion_migracion', label: 'Rotaciones y Migraciones', color: 'blue', tipo: 'atributo', key: 'rotacion', value: 'presente', symbol: '⇄' },
        { id: 'diente_sano', label: 'Diente Sano (General)', color: '#232d8dff', tipo: 'condicion', value: 'sano', symbol: '✓' },

        // Fila 8
        { id: 'carilla_desadaptada', label: 'Carilla Desadaptada', color: 'red', tipo: 'sector' },
        { id: 'paciente_edentulo', label: 'Paciente Edéntulo', color: 'purple', tipo: 'macro', symbol: '🦷' },
        { id: 'vacio_1', label: '', color: 'transparent', tipo: 'none' },
        { id: 'vacio_2', label: '', color: 'transparent', tipo: 'none' }
    ];


    // Cargar Usuario y Lista al iniciar

    useEffect(() => {
        if (show) {
            let user = {};
            if (localStorage.getItem('userdata')) {
                user = JSON.parse(localStorage.getItem('userdata'));
                setUserData(user);
            }

            const config = {
                headers: {
                    Authorization: 'Bearer ' + user.access_token
                }
            }

            // FETCH DEL PERFIL PARA NOMBRE EXACTO
            axios.get('/perfil', config)
                .then(response => {
                    if (response.status === 200) {
                        setProfesionalName(response.data.name + ' ' + response.data.lastname);
                    }
                })
                .catch(error => {
                    console.log(error);
                    setProfesionalName(`${user.name || ''} ${user.lastname || ''}`);
                });

            // FETCH ENCABEZADO PERSONALIZADO
            axios.get('/encabezado-personalizado?uid=' + user.user_id, config)
                .then(response => {
                    if (response.status === 200 && response.data && response.data.estado === 1) {
                        setEncabezadoPersonalizado(response.data);
                    }
                })
                .catch(error => {
                    console.log('No hay encabezado personalizado habilitado:', error);
                    setEncabezadoPersonalizado(null);
                });

            cargarOdontogramas();
            setView('list');
            setDientesState({});
        }
    }, [show, pacienteId]);

    const cargarOdontogramas = async () => {
        setLoading(true);
        try {
            const userStr = localStorage.getItem('userdata');
            const token = userStr ? JSON.parse(userStr).access_token : '';
            const config = { headers: { Authorization: `Bearer ${token}` } };

            const response = await axios.get(`/odontogramas-paciente?paciente_id=${pacienteId}`, config);
            setOdontogramas(response.data);

        } catch (err) {
            console.error(err);
            setOdontogramas([]);
        } finally {
            setLoading(false);
        }
    };

    const handleNuevoOdontograma = () => {
        if (odontogramas.length > 0) {
            const confirmarCopia = window.confirm("¿Desea cargar el estado del último odontograma registrado para dar continuidad?");
            if (confirmarCopia) {
                const ultimo = odontogramas[0];
                try {
                    const estadoAnterior = typeof ultimo.datos === 'string' ? JSON.parse(ultimo.datos) : ultimo.datos;
                    setDientesState(estadoAnterior);
                } catch (e) {
                    console.error("Error parseando datos anteriores", e);
                    setDientesState({});
                }
            } else {
                setDientesState({});
            }
        } else {
            setDientesState({});
        }

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hour = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');
        setFechaHora(`${year}-${month}-${day}T${hour}:${min}`);

        setObservaciones('');
        setView('create');
    };

    const handleVerOdontograma = (item) => {
        try {
            const estado = typeof item.datos === 'string' ? JSON.parse(item.datos) : item.datos;
            setDientesState(estado);
            setFechaHora(item.fecha_hora || item.created_at);
            setProfesionalName(item.profesional_nombre || 'Desconocido');
            setObservaciones(item.observaciones || '');
            setView('show');
        } catch (e) {
            console.error(e);
            alert("Error al cargar los datos del odontograma.");
        }
    };

    const guardarOdontograma = async () => {
        setLoading(true);
        try {
            const userStr = localStorage.getItem('userdata');
            const token = userStr ? JSON.parse(userStr).access_token : '';
            const userId = userData ? userData.user_id : null;

            const payload = {
                paciente_id: pacienteId,
                users_id: userId,
                client_id: userData ? userData.client_id : null,
                fecha_hora: fechaHora,
                datos: JSON.stringify(dientesState),
                observaciones: observaciones
            };

            const config = { headers: { Authorization: `Bearer ${token}` } };
            await axios.post('/odontograma', payload, config);

            alert("Odontograma guardado correctamente.");
            cargarOdontogramas();
            setView('list');
        } catch (err) {
            console.error(err);
            alert('Error al guardar el odontograma. Verifique su conexión.');
        } finally {
            setLoading(false);
        }
    };

    // Función para generar encabezado (Copia de ModalFormulas)
    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    // Función descargar PDF
    const descargarPdfOdontograma = () => {
        var opt = {
            margin: 10,
            filename: `odontograma-${paciente ? pacienteId : 'paciente'}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'landscape' } // Landscape para que quepa mejor todo el odontograma
        };

        // Encabezado
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // Datos del Paciente
        const nombreCompleto = paciente ?
            `${paciente.primerNombre || ''} ${paciente.segundoNombre || ''} ${paciente.primerApellido || ''} ${paciente.segundoApellido || ''}`.trim() :
            'Paciente';
        const documento = paciente ? `${paciente.tipoDocumento || ''} ${paciente.numeroDocumento || ''}` : '';

        // Contenido del Odontograma (Capturado del DOM)
        // Buscamos el contenedor que tiene el odontograma visual
        const odontogramaElement = document.querySelector('.odontograma-container');
        const odontogramaHTML = odontogramaElement ? odontogramaElement.outerHTML : '<div>Error al capturar gráfico</div>';

        // Construir string HTML
        let contenidoImpresion = `
            <div style="font-family: Arial, sans-serif; font-size: 12px;">
                ${encabezadoHTML}
                <div style="border-bottom: 2px solid #eee; padding-bottom: 10px; margin-bottom: 20px;">
                    <h2 style="text-align: center; color: #333; margin-bottom: 5px;">ODONTOGRAMA</h2>
                    <table style="width: 100%; margin-top: 10px;">
                        <tr>
                            <td><strong>Paciente:</strong> ${nombreCompleto}</td>
                            <td><strong>Documento:</strong> ${documento}</td>
                            <td><strong>Fecha:</strong> ${fechaHora}</td>
                        </tr>
                        <tr>
                             <td colspan="3"><strong>Profesional Tratante:</strong> ${profesionalName}</td>
                        </tr>
                    </table>
                </div>

                <div style="margin-bottom: 20px; text-align: center;">
                    ${odontogramaHTML}
                </div>

                <div style="margin-top: 20px; border: 1px solid #eee; padding: 10px; border-radius: 5px; background: #f9f9f9;">
                    <strong>Observaciones:</strong><br/>
                    <p style="white-space: pre-wrap;">${observaciones || 'Sin observaciones.'}</p>
                </div>
            </div>
        `;

        html2pdf(contenidoImpresion, opt);
    };

    // --- Lógica del Odontograma (Click Handler) ---
    const handleDienteClick = (numero, zona) => {
        if (view === 'show') return;

        setDientesState(prevState => {
            const newState = { ...prevState };
            const diente = newState[numero] || { sectores: {}, atributos: {} };

            // 1. HERRAMIENTA LIMPIAR TODO EL DIENTE
            if (herramienta.id === 'limpiar_diente') {
                delete newState[numero];
                return newState;
            }

            // 2. REGLAS CLÍNICAS: ESTADOS CRÍTICOS (Ausente, Extraído, Exodoncia, Sano)
            const esEstadoCritico = ['ausente', 'extraccion', 'exodoncia_indicada', 'sano'].includes(herramienta.value);

            if (esEstadoCritico) {
                const yaEstaPuesto = diente.condicion === herramienta.value;
                if (yaEstaPuesto) {
                    delete newState[numero];
                } else {
                    // Al marcar como crítico o sano, se pierde todo lo demás (sectores y atributos)
                    // Nota: 'sano' también limpia todo para indicar que el diente no tiene patologías ni tratamientos.
                    newState[numero] = { sectores: {}, atributos: {}, condicion: herramienta.value };
                }
                return newState;
            }

            // Si el diente está marcado como ausente o extraído, bloqueamos cualquier otra acción
            // Excepto si se quiere cambiar la condición o limpiar el diente (ya manejado arriba)
            if (['ausente', 'extraccion'].includes(diente.condicion) && herramienta.tipo !== 'condicion') {
                return prevState;
            }

            // Inicializar si no existe, o CLONAR si existe para no mutar el estado anterior (Immutability Fix)
            if (!newState[numero]) {
                newState[numero] = { sectores: {}, atributos: {} };
            } else {
                newState[numero] = {
                    ...newState[numero],
                    sectores: { ...(newState[numero].sectores || {}) },
                    atributos: { ...(newState[numero].atributos || {}) }
                };
            }
            const currentDiente = newState[numero];

            // 3. REGLAS PARA SECTORES (Caries, Resinas, Carillas)
            if (herramienta.tipo === 'sector') {
                // REGLA: No se permiten sectores sobre un Implante
                if (currentDiente.atributos?.implante) {
                    return prevState;
                }

                // REGLA: No se permiten carillas si hay una Corona (la corona cubre todo)
                if (herramienta.id.includes('carilla') && currentDiente.atributos?.corona) {
                    return prevState;
                }

                if (herramienta.id === 'limpiar_sector') {
                    const newSectores = { ...currentDiente.sectores };
                    delete newSectores[zona];
                    currentDiente.sectores = newSectores;
                } else {
                    // Toggle para el sector específico
                    if (currentDiente.sectores[zona] === herramienta.id) {
                        const newSectores = { ...currentDiente.sectores };
                        delete newSectores[zona];
                        currentDiente.sectores = newSectores;
                    } else {
                        currentDiente.sectores = {
                            ...currentDiente.sectores,
                            [zona]: herramienta.id
                        };
                    }
                }
            }

            // 4. REGLAS PARA ATRIBUTOS Y CONDICIONES (Coronas, Implantes, Endodoncias, etc.)
            else if (herramienta.tipo === 'atributo' || herramienta.tipo === 'condicion') {
                const key = herramienta.key;
                const value = herramienta.value;

                // Verificamos si ya está puesto para Toggle
                const yaEstaPuesto = (herramienta.tipo === 'atributo' && currentDiente.atributos?.[key] === value) ||
                    (herramienta.tipo === 'condicion' && currentDiente.condicion === value);

                if (yaEstaPuesto) {
                    if (herramienta.tipo === 'atributo') {
                        const newAtributos = { ...currentDiente.atributos };
                        delete newAtributos[key];
                        currentDiente.atributos = newAtributos;
                    } else {
                        delete currentDiente.condicion;
                    }
                } else {
                    // APLICAR NUEVO TRATAMIENTO CON REGLAS DE COMPATIBILIDAD

                    // A. IMPLANTE: Limpia endodoncia, sellantes y todos los sectores (caries/resinas)
                    if (herramienta.id.includes('implante')) {
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };
                        delete currentDiente.atributos.endodoncia;
                        delete currentDiente.atributos.sellante;
                        delete currentDiente.atributos.nucleo;
                        currentDiente.sectores = {};
                    }

                    // B. ENDODONCIA: Incompatible con Implante
                    else if (herramienta.id.includes('endodoncia')) {
                        if (currentDiente.atributos?.implante) return prevState;
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };
                    }

                    // C. CORONA / PROVISIONAL: Limpia sellantes y carillas, y son excluyentes entre sí
                    else if (herramienta.id.includes('corona') || herramienta.id.includes('provisional')) {
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };

                        // Exclusividad mutua entre corona y provisional
                        if (key === 'corona') delete currentDiente.atributos.provisional;
                        if (key === 'provisional') delete currentDiente.atributos.corona;

                        // Eliminar sellante si existe
                        delete currentDiente.atributos.sellante;
                        // Eliminar sectores de carilla si existen
                        const newSectores = { ...currentDiente.sectores };
                        Object.keys(newSectores).forEach(z => {
                            if (newSectores[z]?.includes('carilla')) delete newSectores[z];
                        });
                        currentDiente.sectores = newSectores;
                    }

                    // D. SELLANTE: Incompatible con Implante y Corona
                    else if (herramienta.id.includes('sellante')) {
                        if (currentDiente.atributos?.implante || currentDiente.atributos?.corona) return prevState;
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };
                    }

                    // E. NUCLEO: Incompatible con Implante (normalmente)
                    else if (herramienta.id.includes('nucleo')) {
                        if (currentDiente.atributos?.implante) return prevState;
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };
                    }

                    // RESTO DE ATRIBUTOS / CONDICIONES
                    else if (herramienta.tipo === 'atributo') {
                        currentDiente.atributos = {
                            ...currentDiente.atributos,
                            [key]: value
                        };
                    } else {
                        currentDiente.condicion = value;
                    }
                }
            }
            return newState;
        });
    };

    // --- Renderizado de Botones ---
    const renderButton = (tool) => {
        const isSelected = herramienta.id === tool.id;

        let iconStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '24px',
            height: '24px',
            marginRight: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '14px',
            fontWeight: 'bold',
            flexShrink: 0
        };

        let innerContent = null;

        if (tool.id.includes('resina')) {
            const color = tool.id.includes('presente') ? 'blue' : 'red';
            iconStyle.backgroundImage = `repeating-linear-gradient(45deg, white, white 2px, ${color} 2px, ${color} 4px)`;
        } else if (tool.id.includes('carilla')) {
            const color = tool.id.includes('presente') ? 'blue' : 'red';
            iconStyle.backgroundImage = `linear-gradient(90deg, ${color} 1px, transparent 1px)`;
            iconStyle.backgroundSize = '4px 100%';
        } else if (tool.tipo === 'sector' && !tool.symbol) {
            iconStyle.backgroundColor = tool.color;
        } else {
            iconStyle.backgroundColor = 'transparent';
            iconStyle.border = 'none';
            iconStyle.color = tool.color;
            innerContent = tool.symbol;

            if (tool.id === 'limpiar_diente') innerContent = '✨';
            if (tool.id === 'limpiar_sector') innerContent = '🧹';

            if (tool.id === 'exodoncia_indicada') {
                innerContent = '❌';
                iconStyle.color = 'red';
            }
        }

        return (
            <div className="col-md-3 mb-2" key={tool.id}>
                <button
                    className={`btn btn-sm w-100 ${isSelected ? 'btn-primary' : 'btn-outline-secondary'}`}
                    style={{
                        opacity: view === 'show' ? 0.6 : 1,
                        visibility: tool.tipo === 'none' ? 'hidden' : 'visible',
                        textAlign: 'left',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        padding: '6px 10px',
                        fontSize: '13px'
                    }}
                    onClick={() => {
                        if (tool.tipo === 'none') return; // Seguridad extra
                        if (tool.id === 'paciente_edentulo') {

                            if (window.confirm("¿Está seguro de marcar al paciente como edéntulo? Esto marcará como extraídos todos los dientes posteriores y anteriores específicos.")) {
                                setDientesState(prevState => {
                                    const newState = { ...prevState };
                                    const dientesEdentulo = [
                                        // Superior Derecha
                                        18, 17, 16, 15, 14, 13, 12, 11,
                                        // Superior Izquierda
                                        21, 22, 23, 24, 25, 26, 27, 28,
                                        // Inferior Derecha
                                        48, 47, 46, 45, 44, 43, 42, 41,
                                        // Inferior Izquierda
                                        31, 32, 33, 34, 35, 36, 37, 38
                                    ];

                                    dientesEdentulo.forEach(num => {
                                        if (!newState[num]) newState[num] = { sectores: {}, atributos: {} };
                                        newState[num].condicion = 'extraccion';
                                    });
                                    return newState;
                                });
                            }
                        } else {
                            setHerramienta(tool);
                        }
                    }}
                    disabled={view === 'show'}
                >
                    <div style={iconStyle}>
                        {innerContent}
                    </div>
                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{tool.label}</span>
                </button>
            </div >
        );
    };

    const renderOdontogramaContent = () => {
        const quadrants = [
            [18, 17, 16, 15, 14, 13, 12, 11],
            [21, 22, 23, 24, 25, 26, 27, 28],
            [55, 54, 53, 52, 51],
            [61, 62, 63, 64, 65],
            [85, 84, 83, 82, 81],
            [71, 72, 73, 74, 75],
            [48, 47, 46, 45, 44, 43, 42, 41],
            [31, 32, 33, 34, 35, 36, 37, 38]
        ];

        const renderRow = (dientes) => (
            <div className="d-flex justify-content-center">
                {dientes.map(num => (
                    <DienteSVG
                        key={num}
                        numero={num}
                        estado={dientesState[num]}
                        onSectorClick={handleDienteClick}
                        style={{ pointerEvents: view === 'show' ? 'none' : 'auto' }}
                    />
                ))}
            </div>
        );

        return (
            <div className="odontograma-container" style={{ overflowX: 'auto', padding: '10px' }}>
                <div className="d-flex justify-content-center mb-2 gap-4">
                    {renderRow(quadrants[0])}
                    <div style={{ width: '20px' }}></div>
                    {renderRow(quadrants[1])}
                </div>
                <div className="d-flex justify-content-center mb-4 gap-4">
                    {renderRow(quadrants[2])}
                    <div style={{ width: '20px' }}></div>
                    {renderRow(quadrants[3])}
                </div>
                <div className="d-flex justify-content-center mb-2 gap-4">
                    {renderRow(quadrants[4])}
                    <div style={{ width: '20px' }}></div>
                    {renderRow(quadrants[5])}
                </div>
                <div className="d-flex justify-content-center gap-4">
                    {renderRow(quadrants[6])}
                    <div style={{ width: '20px' }}></div>
                    {renderRow(quadrants[7])}
                </div>
            </div>
        );
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    Odontograma {view === 'create' ? '(Nuevo)' : view === 'show' ? '(Solo Lectura)' : ''}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {view === 'list' && (
                    <div className="container-fluid">
                        <div className="d-flex justify-content-between mb-3">
                            <h4>Historial de Odontogramas</h4>
                            <Button variant="success" onClick={handleNuevoOdontograma}>
                                <i className="fas fa-plus"></i> Nuevo Odontograma
                            </Button>
                        </div>

                        {loading ? <p>Cargando...</p> : (
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Profesional</th>
                                        <th>Observaciones</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {odontogramas.length > 0 ? odontogramas.map((og, idx) => (
                                        <tr key={og.id || idx}>
                                            <td>{og.fecha_hora || og.created_at}</td>
                                            <td>{og.profesional_nombre || 'N/D'}</td>
                                            <td>{og.observaciones}</td>
                                            <td>
                                                <Button size="sm" variant="info" onClick={() => handleVerOdontograma(og)}>
                                                    <i className="fas fa-eye"></i> Ver
                                                </Button>
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan="4" className="text-center">No hay registros previos.</td></tr>
                                    )}
                                </tbody>
                            </Table>
                        )}
                    </div>
                )}

                {(view === 'create' || view === 'show') && (
                    <div className="container-fluid">
                        <div className="card mb-3">
                            <div className="card-body py-2">
                                <Row>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Fecha y Hora</Form.Label>
                                            <Form.Control
                                                type="datetime-local"
                                                value={fechaHora}
                                                onChange={(e) => setFechaHora(e.target.value)}
                                                readOnly={view === 'show'}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={8}>
                                        <Form.Group>
                                            <Form.Label><i className="fas fa-user-md"></i> Profesional Tratante</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={profesionalName}
                                                readOnly
                                                style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                            />
                                            <small className="text-muted">Usuario que realiza el odontograma</small>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                        </div>

                        <div className="card mb-3">
                            <div className="card-body bg-light text-center">
                                {renderOdontogramaContent()}
                            </div>
                        </div>

                        {view === 'create' && (
                            <div className="card mb-3">
                                <div className="card-header py-1">Herramientas</div>
                                <div className="card-body py-2">
                                    <div className="row">
                                        {herramientas.map(renderButton)}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="mt-3">
                            <Form.Group>
                                <Form.Label>Observaciones</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={observaciones}
                                    onChange={(e) => setObservaciones(e.target.value)}
                                    readOnly={view === 'show'}
                                />
                            </Form.Group>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                {view === 'list' ? (
                    <Button variant="secondary" onClick={onHide}>Cerrar</Button>
                ) : (
                    <>
                        <Button variant="secondary" onClick={() => setView('list')}>
                            <i className="fas fa-arrow-left"></i> Volver a Lista
                        </Button>

                        {/* BOTÓN DESCARGA PDF - SOLO EN MODO LECTURA */}
                        {view === 'show' && (
                            <Button variant="danger" onClick={descargarPdfOdontograma} className="ml-2">
                                <i className="fas fa-file-pdf"></i> Descargar PDF
                            </Button>
                        )}

                        {view === 'create' && (
                            <Button variant="primary" onClick={guardarOdontograma} disabled={loading}>
                                {loading ? 'Guardando...' : 'Guardar Odontograma'}
                            </Button>
                        )}
                    </>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ModalOdontograma;
